<template>
  <v-card outlined>
    <v-card-title class="display-1">Try our other tools</v-card-title>
    <v-card-text class="title text-left">
      <p>
        <a href="http://www.fpshelper.com/en/conv/">Sensitivity Converter</a>
      </p>
      <p>
        <a href="http://www.fpshelper.com/en/advanced/"
          >Advanced Sensitivity Converter</a
        >
      </p>
      <p>
        <a href="http://www.fpshelper.com/en/reaction/">Reaction Time Test</a>
      </p>
      <p>
        <a href="http://www.fpshelper.com/en/singleshot/"
          >3D Aim Trainer: Single Shot</a
        >
      </p>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "InnerLink",
  data: () => ({}),
  methods: {},
};
</script>
